import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=1a9c9452&scoped=true"
import script from "./TemplateInfo.vue?vue&type=script&lang=js"
export * from "./TemplateInfo.vue?vue&type=script&lang=js"
import style0 from "./TemplateInfo.vue?vue&type=style&index=0&id=1a9c9452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c9452",
  null
  
)

export default component.exports